/* Catálogo de servicios. Los códigos QX se usan en el catálogo, en "Para quién"
   y en la hoja de encargo: si un código deja de referenciarse, sobra. */

export const SERVICES = [
  {
    id: 'QX–01',
    es: {
      name: 'Webs y plataformas',
      line: 'Desde una web corporativa de cinco páginas hasta una plataforma con área de clientes y cobros.',
      examples: ['Web corporativa con un gestor de contenidos que puedas tocar tú', 'Área privada para clientes', 'Plataforma con suscripciones y pagos'],
      deliver: ['El código, en tu repositorio', 'El despliegue en tu cuenta de hosting', 'Un manual corto para quien la mantenga'],
    },
    en: {
      name: 'Websites and platforms',
      line: 'From the company website to a platform with users, payments and an admin panel.',
      examples: ['Company website with a CMS your team can edit', 'Private client area', 'Platform with subscriptions and payments'],
      deliver: ['The code, in your repository', 'Deployment on your hosting account', 'A short manual for whoever maintains it'],
    },
  },
  {
    id: 'QX–02',
    es: {
      name: 'Herramientas internas',
      line: 'La aplicación que sustituye al Excel compartido que solo sabe tocar una persona.',
      examples: ['Gestor de expedientes con plazos y avisos', 'Panel de seguimiento de campañas por cliente', 'Agenda y fichas de pacientes para una consulta'],
      deliver: ['La aplicación funcionando, con tus datos migrados', 'Usuarios y permisos por rol', 'Formación para quien la vaya a usar'],
    },
    en: {
      name: 'Internal tools',
      line: 'The program that replaces the shared spreadsheet nobody dares to touch any more.',
      examples: ['Case manager with deadlines and reminders', 'Campaign tracking dashboard per client', 'Scheduling and patient records for a clinic'],
      deliver: ['The app running, with your data migrated', 'Users and role-based permissions', 'Training for the people who will use it'],
    },
  },
  {
    id: 'QX–03',
    es: {
      name: 'Integraciones',
      line: 'Das de alta un cliente en el CRM y ya aparece en facturación y en el calendario.',
      examples: ['Contactos de formularios y anuncios que entran directos al CRM', 'Facturas emitidas que llegan solas a contabilidad'],
      deliver: ['Las conexiones en marcha y vigiladas', 'Un aviso cuando una de ellas falla', 'Documentación de cada flujo'],
    },
    en: {
      name: 'Integrations',
      line: 'Your CRM, invoicing and calendar passing data to each other, with nobody copying and pasting.',
      examples: ['Leads from forms and ads going straight into the CRM', 'Issued invoices landing in accounting by themselves'],
      deliver: ['The connections running and monitored', 'An alert when one of them fails', 'Documentation for every flow'],
    },
  },
  {
    id: 'QX–04',
    es: {
      name: 'Automatización con IA',
      line: 'La IA lee los contratos o el correo entrante y deja el borrador preparado. Lo dudoso pasa por una persona.',
      examples: ['Sacar partes, fechas e importes de contratos', 'Clasificar y repartir los correos de una bandeja compartida', 'Primeros borradores de informes a partir de datos de campaña'],
      deliver: ['El sistema dentro de tus herramientas', 'Un registro de cada decisión, para poder revisarla', 'Pruebas con casos reales antes de ponerlo en marcha'],
    },
    en: {
      name: 'AI automation',
      line: 'Reading contracts, sorting emails or drafting documents. Every doubtful case goes to a person before moving on.',
      examples: ['Pulling parties, dates and amounts out of contracts', 'Sorting and routing emails from a shared inbox', 'First drafts of reports from campaign data'],
      deliver: ['The system inside your tools', 'A log of every decision, so it can be reviewed', 'Testing on real cases before it goes live'],
    },
  },
  {
    id: 'QX–05',
    es: {
      name: 'Consultas a tus documentos',
      line: 'Preguntas por tus expedientes o tus manuales y la respuesta cita el documento del que sale.',
      examples: ['Consultas sobre los escritos y la jurisprudencia del propio despacho', 'Preguntas sobre protocolos internos', 'Respuestas para el equipo de atención al cliente'],
      deliver: ['El asistente dentro de tus herramientas', 'Control de quién puede consultar qué', 'La opción de que los documentos no salgan de tu infraestructura'],
    },
    en: {
      name: 'Assistants over your documents',
      line: 'A search box you ask in plain words, which answers by quoting the document it took the answer from.',
      examples: ["Questions about the firm's own filings and case law", 'Questions about internal protocols', 'Answers for the customer support team'],
      deliver: ['The assistant inside your tools', 'Control over who can query what', 'The option to keep documents on your own infrastructure'],
    },
  },
  {
    id: 'QX–06',
    es: {
      name: 'Mantenimiento',
      line: 'Lo mantenemos al día. Si algo falla, te contesta alguien que conoce el proyecto.',
      examples: ['Bolsa de horas mensual', 'Avisos automáticos si algo deja de funcionar', 'Actualizaciones de seguridad'],
      deliver: ['Una persona que conoce el sistema', 'Un informe mensual de lo que se ha hecho'],
    },
    en: {
      name: 'Maintenance',
      line: 'We stay on after delivery: incidents, updates and improvements.',
      examples: ['Monthly block of hours', 'Automatic alerts if something stops working', 'Security updates'],
      deliver: ['One person who knows the system', 'A monthly report of what was done'],
    },
  },
];

export const anchorOf = (id) => `qx-${id.slice(-2)}`;

/* Pide un servicio desde cualquier parte de la página: la hoja de encargo lo recoge */
export function requestService(id) {
  window.dispatchEvent(new CustomEvent('qx:request', { detail: id }));
}
